import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  public formatDate(inputDate: Date) {
    const dateTimeformat = new Intl.DateTimeFormat('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
    return dateTimeformat.format(inputDate);
  }

  public isEmailFormatValid(email) {
    const regExp = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,9}\b$/i;    //need to varify regex for email
    return regExp.test(String(email).toLowerCase());
  }

  //This is a new method for validating email, the old method isEmailFormatValid(email) is not fully correct
  public validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  /*Adding centralized method required for Credit Card payment */
  async isSafari() {
    return false;//for test only
    //this may not be fully correct rework needed
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari;
  }
}
